import { Sound } from "@pixi/sound";
import { SoundsResourcePackage } from "./SoundsResourcePackage";

export class SoundsResourcePackageWrapper extends SoundsResourcePackage {
    private static readonly SOUND_VOLUME = 0.20;

    public override resource<T>(name: string): T {
        const resource = super.resource<T>(name);
        if (resource instanceof Sound) {
            resource.volume = SoundsResourcePackageWrapper.SOUND_VOLUME;
        }
        return resource;
    }
}
